export default [
  '<header class="container-fluid">',
  '  <nav class="navbar navbar-light bg-transparent border-bottom">',
  '    <div class="container-fluid">',
  '     <a class="navbar-brand" href="#">',
  '       <img src="https://res.cloudinary.com/missada/image/upload/v1645340728/Tf.js%20Playground/tfjs_playground_smaller_alt_3.png" alt="" width="30" height="30" class="d-inline-block align-text-top">',
  '       USE Playground',
  '       <span class="sub-heading">',
  '         Powered by TF.js',
  '       </span>',
  '     </a>',
  '    </div>',
  '  </nav>',
  '</header>',
  '<main>',
  '  <div class="container pt-3">',
  '    <h1>TensorFlow.js Universal Sentence Encoder Model Playground.</h1>',
  '    <p>',
  '      The Universal Sentence Encoder model for question answering (USE QnA) is a model that encodes question and answer texts into 100-dimensional embeddings. The dot product of these embeddings measures how well the answer fits the question. This playground uses this model to compare a series of queries and answers to show how well each answer fits each question.',
  '    </p>',
  '    <button type="button" class="btn btn-warning mb-3 me-2" id="clearQuestions">Clear Sample Questions</button>',
  '    <button type="button" class="btn btn-warning mb-3" id="clearAnswers">Clear Sample Answers</button>',
  '',
  '    <form id="useModelForm">',
  '      <div class="mb-3">',
  '        <label for="questions" class="form-label"><b>Questions</b></label>',
  '        <textarea class="form-control" id="questions" rows="3" name="questions" aria-describedby="questionsInputHelp" placeholder="Enter your questions with each one on a new line..." value="" required></textarea>',
  '        <div id="questionsInputHelp" class="form-text text-body">',
  '          Use the sample questions provided or feel free to clear it and paste your own sentences in the text area which each one on a new line.',
  '        </div>',
  '      </div>',
  '',
  '      <div class="mb-3">',
  '        <label for="sentences" class="form-label"><b>Answers</b></label>',
  '        <textarea class="form-control" id="answers" rows="3" name="answers" aria-describedby="answersInputHelp" placeholder="Enter your questions with each one on a new line..." value="" required></textarea>',
  '        <div id="answersInputHelp" class="form-text text-body">',
  '          Use the sample answers provided or feel free to clear it and paste your own answers in the text area which each one on a new line.',
  '        </div>',
  '      </div>',
  '',
  '      <div class="mb-3">',
  '        <button type="submit" class="btn btn-warning" id="submit">Compare</button>',
  '      </div>',
  '    </form>',
  '',
  '    <div class="card my-5">',
  '      <div class="card-body">',
  '        <div id="error"></div>',
  '        <div id="outputContainer"></div>',
  '      </div>',
  '    </div>',
  '  </div>',
  '</main>',
  '',
  '',
].join('\n');
